import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarWeek.vue?vue&type=style&index=0&id=4ba7deae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba7deae"]])

export default __exports__